module.exports = __webpack_public_path__ + "media/images/page/labo-01-d0e97164a21b6b5f89cd531d906a07f4.webp";